"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFirestoreAdapter = void 0;
const common_1 = require("@mods-dev/common");
const utils_1 = require("./utils");
const BATCH_SIZE = 500;
function createFirestoreAdapter(props) {
    return {
        store: store(props),
        find: find(props),
        search: search(props),
        stats: stats(props),
    };
}
exports.createFirestoreAdapter = createFirestoreAdapter;
const store = ({ firestore, logger }) => async (ecosystem, name, data) => {
    const path = utils_1.getFirestoreDocPath(name);
    logger.info(`[data-layer] Storing ${ecosystem}@${path}`);
    await firestore
        .collection('ecosystems')
        .doc(ecosystem)
        .collection('mods')
        .doc(path)
        .set(data);
};
const find = ({ firestore, logger }) => async (ecosystem, name) => {
    const path = utils_1.getFirestoreDocPath(name);
    logger.info(`[data-layer] Finding ${ecosystem}@${path}`);
    const doc = await firestore
        .collection('ecosystems')
        .doc(ecosystem)
        .collection('mods')
        .doc(path)
        .get();
    return doc.exists ? doc.data() : null;
};
const search = ({ firestore, logger }) => async (ecosystem, term) => {
    throw new Error('Not implemented');
};
const stats = ({ firestore, logger }) => async (ecosystem) => {
    throw new Error('Not implemented');
};
const purgeSnapshot = (firestore) => (snapshot) => {
    return common_1.asyncForEach(common_1.chunk(snapshot.docs, BATCH_SIZE), async (batch) => {
        return firestore.runTransaction(async (transaction) => {
            batch.forEach((doc) => {
                transaction.delete(doc.ref);
            });
        });
    });
};
const snapshotToArray = (firestore) => (snapshot) => {
    const results = [];
    snapshot.forEach((doc) => {
        results.push(doc.data());
    });
    return results;
};
const batch = (firestore) => (items, callback) => {
    return common_1.asyncForEach(common_1.chunk(items, BATCH_SIZE), async (batch) => {
        return firestore.runTransaction(async (transaction) => {
            return callback(transaction, batch);
        });
    });
};
//# sourceMappingURL=adapter.js.map